import React, { useState } from "react";
import "../../styles/Main.css";
import { Button, Form } from "react-bootstrap";
import { BsInfoSquare } from "react-icons/bs";
import conv from "../../assets/lang/i18n";
import { Page1Meta } from "../../assets/meta/MetaTag";
import MainHeader from "./MainHeader";
import Footer from "./Footer";

const MainPage = () => {
  const thisYear = new Date().getFullYear();
  const [Currentlang, setCurrentlang] = useState(conv.language); //브라우저언어감지
  const [validated, setValidated] = useState(false);
  const [isExplainSpread, setIsExplainSpread] = useState(false);
  const [isSpread, setIsSpread] = useState(false);

  const expectPeriod = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
  const selectStartYearList = [];
  const selectEndYearList = [];
  for (let i = 20; i >= 0; i--) {
    selectStartYearList.push(thisYear - i);
  }
  for (let i = 0; i < 20; i++) {
    selectEndYearList.push(thisYear - i);
  }
  const [SelectedStartYear, setSelectedStartYear] = useState(
    selectStartYearList[0]
  );
  const [SelectedEndYear, setSelectedEndYear] = useState(selectEndYearList[0]);
  const [StartYearAmt, setStartYearAmt] = useState(0);
  const [EndYearAmt, setEndYearAmt] = useState(0);
  const [ProfitRate, setProfitRate] = useState(0);
  const [AfterPeriod, setAfterPeriod] = useState(5);
  const [InitialPrice, setInitialPrice] = useState(0);
  const [AfterProfitRate, setAfterProfitRate] = useState(0);
  const handleSelectedStartYear = (e) => {
    setSelectedStartYear(e.target.value.replace(/[^0-9.]/g, ""));
  };
  const handleSelectedEndYear = (e) => {
    setSelectedEndYear(e.target.value.replace(/[^0-9.]/g, ""));
  };
  const handleStartYearAmt = (e) => {
    setStartYearAmt(e.target.value.replace(/[^0-9.]/g, ""));
  };
  const handleEndYearAmt = (e) => {
    setEndYearAmt(e.target.value.replace(/[^0-9.]/g, ""));
  };
  const handleAfterPeriod = (e) => {
    setAfterPeriod(e.target.value.replace(/[^0-9.]/g, ""));
  };
  const handleInitialPrice = (e) => {
    setInitialPrice(e.target.value.replace(/[^0-9.]/g, ""));
  };
  const handleAfterProfitRate = (e) => {
    setAfterProfitRate(e.target.value.replace(/[^0-9.]/g, "")); //숫자와 소숫점 제외한 모든 경우 없앰
  };
  const onLanguageChange = (e) => {
    if (e.target.text === "English" || e.target.text === "영어") {
      conv.changeLanguage("en");
      setCurrentlang("en");
    } else {
      conv.changeLanguage("ko");
      setCurrentlang("ko");
    }
    return Currentlang;
  };
  function handleSubmit(event) {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      funcCalc(); //연간 증가율 계산
    }
    setValidated(true);
    event.preventDefault();
    event.stopPropagation();
  }
  /**시작,끝 기간과 금액 받아서 연평균 복리율 계산해 줌 */
  function funcCalc() {
    const yearGap = SelectedEndYear - SelectedStartYear;
    if (EndYearAmt < 0 || StartYearAmt < 0 || yearGap < 0) {
      alert("Plz input again.");
    } else {
      setProfitRate(
        Math.floor((Math.pow(EndYearAmt / StartYearAmt, 1 / yearGap) - 1) * 100)
      );
      setAfterProfitRate(
        Math.floor((Math.pow(EndYearAmt / StartYearAmt, 1 / yearGap) - 1) * 100)
      );

      setInitialPrice(EndYearAmt);
      setIsSpread(true);
    }
  }

  /**입력된 기준금액 복리율로 기간에 따른 금액변동을 list로 보여줌 */
  function funcSpread(opt) {
    let rstArr = [];
    let principalAmt = +InitialPrice; //형변환
    let rate = +AfterProfitRate / 100;
    let balance = Math.floor(principalAmt * (1 + rate));
    let interest = +AfterProfitRate;
    let depIncome = balance - principalAmt;
    if (principalAmt < 1) {
      return rstArr;
    }
    for (let i = 1; i <= AfterPeriod; i++) {
      rstArr.push(
        <tr key={i}>
          <td>{thisYear + i}</td>
          <td>
            {principalAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </td>
          <td>{interest.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%</td>
          <td>{balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
          <td>{depIncome.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
        </tr>
      );
      principalAmt = balance;
      balance = Math.floor(principalAmt * (1 + rate));
      depIncome = balance - InitialPrice;
    }
    return opt === "rstPrice"
      ? principalAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      : rstArr;
  }

  return (
    <div>
      {Page1Meta()}
      <MainHeader paramChangeLanguage={onLanguageChange} />

      <div className="container">
        <main>
          <div className="py-4 row">
            <h2 className="text-left mb-4 col-md-5">
              {conv.t("calc.top_name")}
            </h2>
            <h3 className="col-md-1">
              <BsInfoSquare
                className="p-cursor"
                onClick={() => {
                  isExplainSpread
                    ? setIsExplainSpread(false)
                    : setIsExplainSpread(true);
                }}
              />
            </h3>
            <div className="text-left" hidden={isExplainSpread ? "" : "hidden"}>
              <p>{conv.t("calc.how_to_use1")}</p>
              <p>{conv.t("calc.how_to_use2")}</p>
              <p>{conv.t("calc.how_to_use3")}</p>
              <p>{conv.t("calc.how_to_use4")}</p>
            </div>
          </div>

          <div className="row g-5">
            <div className="col-md-7 col-lg-8">
              <h4 className="mb-3">{conv.t("calc.sub_name")}</h4>
              <Form
                className="needs-validation"
                noValidate
                validated={validated}
                onSubmit={handleSubmit}
              >
                <div className="row g-3">
                  <Form.Group className="col-sm-6">
                    <Form.Label htmlFor="start-year" className="form-label">
                      {conv.t("calc.str_year")}
                    </Form.Label>
                    <Form.Select
                      className="form-select"
                      id="start-year"
                      onChange={handleSelectedStartYear}
                      required
                    >
                      {selectStartYearList.map((item, idx) => (
                        <option value={item} key={idx}>
                          {item}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {conv.t("calc.str_year_vld")}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="col-sm-6">
                    <Form.Label htmlFor="start-amount" className="form-label">
                      {conv.t("calc.str_amt")}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      className="form-control"
                      id="start-amount"
                      placeholder={conv.t("calc.str_amt_ph")}
                      min="1"
                      onChange={handleStartYearAmt}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      {conv.t("calc.str_amt_vld")}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="col-sm-6">
                    <Form.Label htmlFor="end-year" className="form-label">
                      {conv.t("calc.end_year")}
                    </Form.Label>
                    <Form.Select
                      className="form-select"
                      id="end-year"
                      onChange={handleSelectedEndYear}
                      required
                    >
                      {selectEndYearList.map((item, idx) => (
                        <option value={item} key={idx}>
                          {item}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {conv.t("calc.end_year_vld")}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="col-sm-6">
                    <Form.Label htmlFor="end-amount" className="form-label">
                      {conv.t("calc.end_amt")}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      className="form-control"
                      id="end-amount"
                      placeholder={conv.t("calc.end_amt_ph")}
                      min="1"
                      onChange={handleEndYearAmt}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      {conv.t("calc.end_amt_vld")}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <hr className="my-4" />
                  <Form.Group className="col-sm-12">
                    <Button
                      className="w-100 btn btn-primary btn-md"
                      type="submit"
                    >
                      {conv.t("calc.call_rst")}
                    </Button>
                  </Form.Group>

                  <Form.Group className="col-sm-6">
                    <Form.Label
                      htmlFor="annual_profit_rate"
                      className="form-label"
                    >
                      {conv.t("calc.rst_profit_rate")}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="form-control"
                      id="annual_profit_rate"
                      value={ProfitRate + " %"}
                      disabled
                    />
                  </Form.Group>

                  <div hidden={isSpread ? "" : "hidden"}>
                    <hr className="my-4" />

                    <Form.Group className="row">
                      <div className="col-md-2">
                        <label htmlFor="sl_period" className="h3 text-muted">
                          After
                        </label>
                      </div>
                      <div className="col-md-3">
                        <select
                          className="form-select"
                          id="sl_period"
                          onChange={handleAfterPeriod}
                          required
                        >
                          {expectPeriod.map((item, idx) => (
                            <option value={item} key={idx}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="sl_period" className="h3 text-muted">
                          years ?
                        </label>
                      </div>
                    </Form.Group>

                    <Form.Group className="row g-3">
                      <div className="col-md-4">
                        <label htmlFor="lb_init_price" className="form-label">
                          {conv.t("calc.lb_init_price")}
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="lb_init_price"
                          placeholder=""
                          value={InitialPrice}
                          onChange={handleInitialPrice}
                          required
                        />
                        <div className="invalid-feedback">
                          {conv.t("calc.lb_init_price_fb")}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="lb_profit_rate" className="form-label">
                          {conv.t("calc.lb_annu_prf_rate")}
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="lb_profit_rate"
                          placeholder=""
                          value={AfterProfitRate}
                          onChange={handleAfterProfitRate}
                          required
                        />
                        <div className="invalid-feedback">
                          {conv.t("calc.lb_annu_prf_rate_fb")}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="lb_final_price" className="form-label">
                          {conv.t("calc.lb_final_price")}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="lb_final_price"
                          placeholder=""
                          value={funcSpread("rstPrice")}
                          disabled
                        />
                      </div>
                    </Form.Group>
                    <hr className="my-4" />
                    <h2>{conv.t("calc.tbl_subject")}</h2>
                    <div className="table-responsive">
                      <table className="table table-striped table-sm">
                        <thead>
                          <tr>
                            <th scope="col">{conv.t("calc.tbl_col_1")}</th>
                            <th scope="col">{conv.t("calc.tbl_col_2")}</th>
                            <th scope="col">{conv.t("calc.tbl_col_3")}</th>
                            <th scope="col">{conv.t("calc.tbl_col_4")}</th>
                            <th scope="col">{conv.t("calc.tbl_col_5")}</th>
                          </tr>
                        </thead>
                        <tbody>{funcSpread()}</tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <hr className="my-4" />
              </Form>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default MainPage;
